import { ModalOverlay } from './ModalOverlay.js'

type Props = {
  folder: { id: string; name: string } | null
  onClose: () => void
  onConfirm: () => void
  isPending?: boolean
}

export function DeleteFolderModal({ folder, onClose, onConfirm, isPending = false }: Props) {
  if (!folder) return null

  return (
    <ModalOverlay
      className="bg-black/50"
      onBackdropClick={onClose}
      onEscape={onClose}
      aria-label="フォルダ削除の確認"
    >
      <div
        className="bg-card border border-border rounded-lg shadow-lg p-6 w-full max-w-md"
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => e.stopPropagation()}
        role="presentation"
      >
        <h2 className="text-lg font-semibold text-foreground">フォルダを削除しますか？</h2>
        <div className="mt-4 space-y-3 text-sm">
          <p className="text-foreground/90">
            「{folder.name}」を削除します。中のプロジェクトは未分類に戻ります（削除はされません）。
          </p>
          <div className="flex justify-end gap-2 pt-2">
            <button
              type="button"
              onClick={onClose}
              disabled={isPending}
              className="px-4 py-2 border border-border rounded-md font-medium text-sm hover:bg-accent transition-colors disabled:opacity-50"
            >
              キャンセル
            </button>
            <button
              type="button"
              onClick={onConfirm}
              disabled={isPending}
              className="px-4 py-2 bg-destructive text-destructive-foreground rounded-md font-medium text-sm disabled:opacity-50 hover:opacity-90 transition-opacity"
            >
              {isPending ? '削除中…' : 'フォルダを削除'}
            </button>
          </div>
        </div>
      </div>
    </ModalOverlay>
  )
}
